var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-item-followup-date"},[(_vm.date)?_c('div',[_c('DateComponent',{attrs:{"date":_vm.date}}),(_vm.isToday)?_c('span',{staticClass:"c-item-followup-date__label"},[_vm._v("Today")]):_vm._e()],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }